/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FileManagementListFileForMemberRequest = {
  groupId: number;
  page?: number;
  perPage?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: FileManagementListFileForMemberRequest.direction | null;
};

export namespace FileManagementListFileForMemberRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
